// Dust Ranger interactions — ported verbatim from the prototype, with null
// guards added so pages without specific elements (calculator, etc) don't error.

(function () {
  'use strict';

  // ---- Scroll progress bar ----
  var bar = document.getElementById('scrollProgress');
  if (bar) {
    window.addEventListener('scroll', function () {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      bar.style.width = max > 0 ? (h.scrollTop / max) * 100 + '%' : '0%';
    }, { passive: true });
  }

  // ---- Nav scrolled state (>60px) ----
  var nav = document.getElementById('mainNav');
  if (nav) {
    var setScrolled = function () {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', setScrolled, { passive: true });
    setScrolled();
  }

  // ---- Mobile hamburger menu ----
  var ham = document.getElementById('hamburger');
  var navLinks = document.querySelector('.nav-links');
  if (ham && navLinks) {
    var closeMenu = function () {
      navLinks.classList.remove('is-open');
      ham.classList.remove('is-open');
      ham.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    };
    var openMenu = function () {
      navLinks.classList.add('is-open');
      ham.classList.add('is-open');
      ham.setAttribute('aria-expanded', 'true');
      document.body.classList.add('menu-open');
    };
    ham.setAttribute('aria-expanded', 'false');
    ham.addEventListener('click', function () {
      if (navLinks.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
    // Tap any link inside → close menu (so single-page anchors and inter-page nav both work)
    navLinks.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
    // Escape key closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && navLinks.classList.contains('is-open')) closeMenu();
    });
  }

  // ---- Intersection observer for reveal animations ----
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    document
      .querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale')
      .forEach(function (el) { obs.observe(el); });

    // Protection bar inside step 3 visual
    var pBar = document.querySelector('.protection-bar');
    if (pBar) {
      var pObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            pBar.style.width = '100%';
            pObs.unobserve(e.target);
          }
        });
      }, { threshold: 0.3 });
      pObs.observe(pBar);
    }
  } else {
    document
      .querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale')
      .forEach(function (el) { el.classList.add('visible'); });
  }

  // ---- Parallax blobs ----
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    document.querySelectorAll('.blob').forEach(function (b, i) {
      b.style.transform = 'translateY(' + (y * (0.03 + i * 0.015)) + 'px)';
    });
  }, { passive: true });

  // ---- Smooth anchor scroll ----
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href === '#') return;
    var target = document.querySelector(href);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  // ---- Hero badge spin easter egg (accumulating rotation) ----
  var hBadge = document.getElementById('heroBadge');
  if (hBadge) {
    var hRot = 0;
    hBadge.addEventListener('mouseenter', function () {
      hRot += 15;
      hBadge.style.transform = 'rotate(' + hRot + 'deg) scale(1.08)';
    });
    hBadge.addEventListener('mouseleave', function () {
      hBadge.style.transform = 'rotate(' + hRot + 'deg) scale(1)';
    });
  }

  // ---- Hero stat months auto-cycler (3 → 6 → 9 → 12 → loop) ----
  // Avoids the misleading impression that one treatment = a fixed 12 months.
  var statEl = document.getElementById('statMonths');
  if (statEl) {
    var vals = [3, 6, 9, 12];
    var vi = 0;
    var paused = false;
    statEl.style.cursor = 'pointer';
    statEl.style.transition = 'transform 0.35s ease, opacity 0.35s ease';
    statEl.textContent = vals[0];

    function nextValue() {
      if (paused) return;
      vi = (vi + 1) % vals.length;
      // Fade & shrink → swap → fade & scale back in
      statEl.style.opacity = '0';
      statEl.style.transform = 'scale(0.85)';
      setTimeout(function () {
        statEl.textContent = vals[vi];
        statEl.style.opacity = '1';
        statEl.style.transform = 'scale(1)';
      }, 220);
    }

    // Auto-cycle every 2 seconds
    setInterval(nextValue, 2000);

    // Pause on hover so people can read it
    statEl.addEventListener('mouseenter', function () { paused = true; });
    statEl.addEventListener('mouseleave', function () { paused = false; });

    // Optional: click to manually advance
    statEl.addEventListener('click', function () {
      paused = false; // ensure click still cycles even while hovered
      nextValue();
    });
  }

  // ---- CTA badge — rains badges down the page on click ----
  var ctaB = document.getElementById('ctaBadge');
  if (ctaB) {
    ctaB.style.cursor = 'pointer';
    var rainSrc = ctaB.getAttribute('data-rain-src') || ctaB.src;
    ctaB.addEventListener('click', function () {
      for (var i = 0; i < 8; i++) {
        (function () {
          var b = document.createElement('img');
          b.src = rainSrc;
          b.alt = '';
          b.className = 'badge-rain';
          b.style.width = (20 + Math.random() * 30) + 'px';
          b.style.left = (Math.random() * 100) + 'vw';
          b.style.top = '-40px';
          b.style.animationDuration = (2 + Math.random() * 2) + 's';
          b.style.animationDelay = (Math.random() * 0.5) + 's';
          document.body.appendChild(b);
          setTimeout(function () { b.remove(); }, 5000);
        })();
      }
    });
  }

  // ---- Footer logo glow on double-click ----
  var fLogo = document.querySelector('.footer-brand img');
  if (fLogo) {
    fLogo.style.transition = 'filter 0.3s ease, transform 0.3s ease';
    fLogo.addEventListener('dblclick', function (e) {
      e.preventDefault();
      fLogo.style.filter = 'drop-shadow(0 0 8px rgba(217,162,115,0.9)) drop-shadow(0 0 20px rgba(166,111,63,0.6))';
      fLogo.style.transform = 'scale(1.05)';
      setTimeout(function () {
        fLogo.style.filter = '';
        fLogo.style.transform = '';
      }, 800);
    });
  }
})();
